import moment from 'moment';
import {PREFIX_RH, PREFIX_T} from './behaviour_models_utils';

export const SUMMER_AFTERNOON_FMC = {
  SUMMER_PM: 'S',
  DAYTIME_OVERCAST: 'O'
};

export const DEFAULT_SUMMER_AFTERNOON_FMC = SUMMER_AFTERNOON_FMC.SUMMER_PM;

// Temporarily disabled — hide from Calculation Variables UI and export; calcs use DEFAULT only.
// Re-enable when operators can choose Summer PM vs daytime overcast again.
export const SUMMER_AFTERNOON_FMC_USER_CONFIGURABLE = false;

export const SUMMER_AFTERNOON_FMC_ENUM = {
  'Summer PM (standard)': SUMMER_AFTERNOON_FMC.SUMMER_PM,
  'Daytime (overcast)': SUMMER_AFTERNOON_FMC.DAYTIME_OVERCAST
};

function timeFromWeatherRow(wd) {
  if (typeof wd.sortIndex === 'number') {
    return moment(wd.sortIndex);
  }
  return moment(wd.name, 'ddd DD/MM hh:mm A');
}

export function calculateFFM_PM(wd) {
  const rh = wd[PREFIX_RH];
  const t = wd[PREFIX_T];
  if (typeof rh === 'undefined' || typeof t === 'undefined') {
    return undefined;
  }
  return 2.76 + 0.124 * rh - 0.0187 * t;
}

export function calculateFFM_DT(wd) {
  const rh = wd[PREFIX_RH];
  const t = wd[PREFIX_T];
  if (typeof rh === 'undefined' || typeof t === 'undefined') {
    return undefined;
  }
  return 3.6 + 0.169 * rh - 0.045 * t;
}

export function calculateFFM_NT(wd) {
  const rh = wd[PREFIX_RH];
  const t = wd[PREFIX_T];
  if (typeof rh === 'undefined' || typeof t === 'undefined') {
    return undefined;
  }
  return 3.08 + 0.198 * rh - 0.0483 * t;
}

/** Current FMC — N14 / K6 logic (Oct–Mar afternoon preference; default Summer PM). */
export function calculateFFM_C(wd, vars) {
  const preference = SUMMER_AFTERNOON_FMC_USER_CONFIGURABLE && vars ?
    vars.summer_afternoon_fmc :
    undefined;
  const pref = typeof preference === 'undefined' ? DEFAULT_SUMMER_AFTERNOON_FMC : preference;
  const t = timeFromWeatherRow(wd);
  const hr = t.hours();
  const month = t.month();

  if ((month >= 9 || month <= 2) && hr >= 12 && hr <= 17) {
    if (pref === SUMMER_AFTERNOON_FMC.SUMMER_PM) {
      return calculateFFM_PM(wd);
    }
    if (pref === SUMMER_AFTERNOON_FMC.DAYTIME_OVERCAST) {
      return calculateFFM_DT(wd);
    }
    return calculateFFM_NT(wd);
  }
  if (hr < 8 || hr >= 20) {
    return calculateFFM_NT(wd);
  }
  return calculateFFM_DT(wd);
}



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/shared/ffm.js